module.exports = __webpack_public_path__ + "static/media/appstore.930a932b.webp";